package com.shadowings.gero.data.lessons.chapter5
import com.shadowings.gero.data.lessons.chapter1.getFamousNamesQuiz
import com.shadowings.gero.data.lessons.chapter1.getIntroHieroglyphs2QuizContent
import com.shadowings.gero.data.lessons.chapter1.getIntroductionHieroglyphsQuizContent
import com.shadowings.gero.data.lessons.chapter1.getUni_1QuizContent
import com.shadowings.gero.data.lessons.chapter1.getUni_2QuizContent
import com.shadowings.gero.data.lessons.chapter2.getHieroAnimalsQuizContent
import com.shadowings.gero.data.lessons.chapter2.getHieroFoodQuizContent
import com.shadowings.gero.data.lessons.chapter2.getHieroHumansQuizContent
import com.shadowings.gero.data.lessons.chapter2.getNumberGenderQuizContent
import com.shadowings.gero.data.lessons.chapter2.getPhoneticComplementsQuizContent
import com.shadowings.gero.data.lessons.chapter3.getGenitivoDiretto2QuizContent
import com.shadowings.gero.data.lessons.chapter3.getGenitivoDirettoQuizContent
import com.shadowings.gero.data.lessons.chapter3.getHieroVarieQuizContent
import com.shadowings.gero.data.lessons.chapter3.getListeNomiQuizContent
import com.shadowings.gero.data.lessons.chapter3.getRipassoGenereNumeroQuizContent
import com.shadowings.gero.data.lessons.chapter3.getVocabVarieContent
import com.shadowings.gero.data.lessons.chapter3.getVocabVarieQuizContent
import com.shadowings.gero.data.lessons.chapter4.getApposizioneQuizContent
import com.shadowings.gero.data.lessons.chapter4.getCartigliQuizContent
import com.shadowings.gero.data.lessons.chapter4.getGenitivoIndiretto2QuizContent
import com.shadowings.gero.data.lessons.chapter4.getGenitivoIndirettoQuizContent
import com.shadowings.gero.data.lessons.chapter4.getRoyalNamesFullQuizContent
import com.shadowings.gero.data.lessons.chapter4.getRoyalNamesQuizContent


import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_end_verb_1_alyn_1
import gero.composeapp.generated.resources.exp_content_end_verb_1_alyn_2
import gero.composeapp.generated.resources.exp_content_end_verb_1_alyn_3
import gero.composeapp.generated.resources.exp_content_end_verb_1_nilo_1
import gero.composeapp.generated.resources.exp_content_end_verb_1_zeta_1
import gero.composeapp.generated.resources.exp_content_end_verb_1_zeta_2
import gero.composeapp.generated.resources.exp_content_end_verb_1_zeta_3
import gero.composeapp.generated.resources.exp_content_end_verb_1_zeta_4
import gero.composeapp.generated.resources.exp_content_end_verb_1_zeta_5
import gero.composeapp.generated.resources.exp_title_end_verb_1

fun getEndVerb1Content(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_end_verb_1,
            content = Res.string.exp_content_end_verb_1_zeta_1,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_end_verb_1,
            content = Res.string.exp_content_end_verb_1_zeta_2,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_end_verb_1,
            content = Res.string.exp_content_end_verb_1_alyn_1,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_end_verb_1,
            content = Res.string.exp_content_end_verb_1_nilo_1,
            face = Faces.Sleeping,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_end_verb_1,
            content = Res.string.exp_content_end_verb_1_zeta_3,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_end_verb_1,
            content = Res.string.exp_content_end_verb_1_alyn_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_end_verb_1,
            content = Res.string.exp_content_end_verb_1_zeta_4,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_end_verb_1,
            content = Res.string.exp_content_end_verb_1_alyn_3,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_end_verb_1,
            content = Res.string.exp_content_end_verb_1_zeta_5,
            face = Faces.Serious,
            character = Characters.Zeta,
        )
    )
}

fun getEndVerb1QuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val pool = mutableListOf<IQuizContent>()
    pool.addAll(getIntroductionHieroglyphsQuizContent())
    pool.addAll(getIntroHieroglyphs2QuizContent())
    pool.addAll(getUni_1QuizContent(hiero, words, languageCode))
    pool.addAll(getUni_2QuizContent(hiero, words, languageCode))
    pool.addAll(getFamousNamesQuiz(words, languageCode))
    pool.addAll(getNumberGenderQuizContent())
    pool.addAll(getPhoneticComplementsQuizContent())
    pool.addAll(getHieroFoodQuizContent(hiero, words, languageCode))
    pool.addAll(getHieroAnimalsQuizContent(hiero, words, languageCode))
    pool.addAll(getHieroHumansQuizContent(hiero, words, languageCode))
    pool.addAll(getGenitivoDirettoQuizContent(words, languageCode))
    pool.addAll(getGenitivoDiretto2QuizContent(words, languageCode))
    pool.addAll(getRipassoGenereNumeroQuizContent(words, languageCode))
    pool.addAll(getListeNomiQuizContent(words, languageCode))
    pool.addAll(getHieroVarieQuizContent(hiero, words, languageCode))
    pool.addAll(
        getVocabVarieQuizContent(
            getVocabVarieContent(words, languageCode),
            words,
            languageCode
        )
    )
    pool.addAll(getApposizioneQuizContent(words, languageCode))
    pool.addAll(getGenitivoIndirettoQuizContent(words, languageCode))
    pool.addAll(getGenitivoIndiretto2QuizContent(words, languageCode))
    pool.addAll(getCartigliQuizContent())
    pool.addAll(getRoyalNamesQuizContent(hiero, words, languageCode))
    pool.addAll(getRoyalNamesFullQuizContent(words, languageCode))
    pool.addAll(getHieroVerbs1QuizContent(hiero, words, languageCode))
    pool.addAll(
        getVocabVerbs1QuizContent(
            getVocabVerbs1Content(words, languageCode),
            words,
            languageCode
        )
    )
    pool.addAll(getVerbiIntro1QuizContent())
    pool.addAll(getHieroVerbs2QuizContent(hiero, words, languageCode))
    pool.addAll(
        getVocabVerbs2QuizContent(
            getVocabVerbs2Content(words, languageCode),
            words,
            languageCode
        )
    )
    pool.addAll(getParticipiIntroQuizContent())
    pool.addAll(getRecapVerbiParticipiQuizContent(words, languageCode))
    return pool
}
